module.exports = __webpack_public_path__ + "img/duplicate.70d3c3ae.svg";